import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link, withRouter } from 'react-router-dom';
import { Alert, Button, Table } from 'reactstrap';
import ErrorBoundary from './ErrorBoundary';
import NotAuthenticated from './NotAuthenticated';
import * as Accounts from '../store/Accounts';
import * as paths from '../data/Paths';
import * as Sponsors from '../store/Sponsors';
import * as utility from '../data/Utility';
import * as sortfilter from '../data/SortFilter';

class ManageSponsorsInternal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
			isShowingFilter: false,
			currentFilters: {},
			currentSortDirection: {},
			currentSortingColumn: '',
            allFetched: false
        }
    }

    componentDidMount() {
        Accounts.checkAuthenticated(this.props.accountsState.authenticated, this.props.accountsDispatch);
        this.initialize(null);
    }

    componentDidUpdate(prevProps) {
        this.initialize(prevProps);
    }

    handleSponsorSelected(id) {
        const history = this.props.history;
        if (history.location.pathname === paths.manageSponsors) {
            history.push({
                pathname: paths.sponsor,
                state: {
                    create: false,
                    editing: false,
                    sponsorId: id
                }
            });
        }
    }

    initialize(prevProps) {
        const accountsState = this.props.accountsState;
        const authenticated = Accounts.authenticatedAdministrator(accountsState);
        if (Accounts.authenticatedPrevProps(prevProps, authenticated, accountsState.fetching, !this.state.allFetched)) {
            this.props.sponsorsDispatch.getAll();
            this.setState({
                allFetched: true
            });
        }
    }


	toggleFilter() {
		if ( this.state.isShowingFilter ) {
			this.setState({ currentFilters: {} });
		}
		this.setState({ isShowingFilter: ! this.state.isShowingFilter });
	}

	onSortChange = (currentColumn) => {
		let currentSortDirection = this.state.currentSortDirection;
		let nextSort = 'default';

		switch ( currentSortDirection[currentColumn] ) {
			case "down": nextSort = 'default'; break;
			case "up"  : nextSort = 'down'; break;
			default    : nextSort = 'up'; break;
		}

		let newCurrentSortDirection = {};
		newCurrentSortDirection[currentColumn] = nextSort;

		this.setState({
			currentSortDirection: newCurrentSortDirection,
			currentSortingColumn: currentColumn,
		});
	};

	onFilterChange = (e) => {
		this.setState({ currentFilters: {...this.state.currentFilters, [e.target.name]: e.target.value } });
	};

	ColumnHeader = (props) => {
		sortfilter.filterAssociation[props.recordKey] = props.label;
		let val = this.state.currentFilters[props.label];
		if ( val === undefined ) {
			val = '';
		}
		return <sortfilter.ColHeader value={val} onChange={this.onFilterChange.bind(this)} sortDir={this.state.currentSortDirection} onSortChange={this.onSortChange} showFilter={this.state.isShowingFilter} label={props.label} recordKey={props.recordKey} />
	};


    render() {
        if (!Accounts.authenticatedAdministrator(this.props.accountsState)) {
            return (
                <NotAuthenticated />
            );
        }

        var error = false;
        var message = "";
        var sponsorList = null;

        const sponsors = this.props.sponsorsState.all;
        if (sponsors != null &&
            sponsors.map != null) {
            const editTitle = "Edit";
            var rowNum = 1;

            let sList = [...sponsors].map(sponsor => {
				return ( {...sponsor,
					studies: utility.getNamesFromArray(sponsor.studies)
				});
            });
			sList = sortfilter.filterData( sList, this.state.currentFilters );

            sponsorList = [...sList].sort( sortfilter.sortingDetails(this.state.currentSortingColumn,this.state.currentSortDirection).fn ).map(sponsor => {
                return (
                    <tr key={sponsor.id} onClick={this.handleSponsorSelected.bind(this, sponsor.id)}>
                        <th scope="row">{rowNum++}</th>
                        <td>{sponsor.name}</td>
                        <td>{sponsor.code}</td>
                        <td>{sponsor.studies}</td>
                        <td>
                            <Button className="button-inverse" title={editTitle} tag={Link} to={{ pathname: paths.sponsor, state: { create: false, sponsorId: sponsor.id } }}>{editTitle}</Button>
                        </td>
                    </tr>
                );
            });
        }
        else {
            error = true;
            message = "Error retrieving sponsors.";
        }

        const alertColor = error ? "danger" : "primary";
        const displayMessage = message !== "";

        return (
            <div>
                <h1>Manage Sponsors</h1>
                <Button className="button filter_button" id="btnFilter" title="Filter" onClick={this.toggleFilter.bind(this)}> Filter </Button>
                <br />
                {displayMessage && <Alert color={alertColor}>{message}</Alert>}
                <Table striped hover>
                    <thead>
                        <tr>
                            <th>#</th>
							<this.ColumnHeader label="Name" recordKey="name" />
							<this.ColumnHeader label="Code" recordKey="code" />
							<this.ColumnHeader label="Studies" recordKey="studies" />
                            <th>Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {sponsorList}
                    </tbody>
                </Table>
            </div>
        );
    }
}

const ManageSponsorsConnect = withRouter(connect(
    state => ({
        accountsState: state.accounts,
        sponsorsState: state.sponsors
    }),
    dispatch => ({
        accountsDispatch: bindActionCreators(Accounts.actionCreators, dispatch),
        sponsorsDispatch: bindActionCreators(Sponsors.actionCreators, dispatch)
    })
)(ManageSponsorsInternal));

export default class ManageSponsors extends React.Component {
    render() {
        return (
            <ErrorBoundary>
                <ManageSponsorsConnect />
            </ErrorBoundary>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/ManageSponsors.js